<div class="health-check-container">
  <h2>Health Check dos Serviços</h2>

  <div *ngIf="loading" class="loading">Carregando...</div>
  

  <table class="health-table">
    <tr>
      <th>Serviço</th>
      <th>Status</th>
    </tr>
    <tr *ngFor="let key of healthList">
      <td>{{ key.nome }}</td>
      <td class="status">{{ getStatusIcon(key.ativo) }}</td>
    </tr>
  </table>
</div>
